(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('calendar', {
                parent: 'entity',
                url: '/calendar',
                ncyBreadcrumb: {
                    label: 'Calendar',
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/calendar/calendar.html',
                        controller: 'CalendarController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();
